module.exports = __webpack_public_path__ + "static/media/orderleh_title.348985c2.png";